import { useMemo } from "react";

import { useStore } from "../../utils/ctx/SellingPageContext"

const BrandsFilter = () => {
  const [store, setStore] = useStore((store) => store);
  const { brands, preFilteredModel: filteredModel, preFilteredBrand: filteredBrand, selectedBrands } = useMemo(() => store, [store]);

  if (filteredBrand || filteredModel) {
    return null;
  }

  const handleBrandsFiltersChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const id = e.currentTarget.id;
    if (selectedBrands.includes(id)) {
      return setStore({page: 1, searchQuery: '', selectedBrands: selectedBrands.filter(brand => brand !== e.target.id)})
    }

    return setStore({page: 1, searchQuery: '', selectedBrands: [...selectedBrands, e.target.id]})
  }

  return (
    <>
      <b>Por marca</b>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 mt-2 mb-6">
        {brands &&
          brands.map(brand => (
            <div key={brand.name} className="my-2 flex mr-2 items-center h-4">
              <input
                className="!h-4 !w-4 !md:h-5 !md:w-5"
                type="checkbox"
                id={brand.name}
                onChange={handleBrandsFiltersChange}
                checked={selectedBrands?.includes(brand.name)}
              />
              <label htmlFor={brand.name}>{brand.name}</label>
            </div>
          ))}
      </div>
    </>
  )
}

export default BrandsFilter;
